import React, { Fragment, useState } from "react";
import "../styles/home.scss";
import CustomHelmet from "../component/reusable/Helmet";
import { home2, homeBanner } from "../assets/images";
import { GiNothingToSay } from "react-icons/gi";
import { BiLogoPlayStore } from "react-icons/bi";
import { PiStarFourThin } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "alpha-ui";
import { FaPlusCircle, FaUser } from "react-icons/fa";
import { HiChatBubbleOvalLeftEllipsis } from "react-icons/hi2";
import Slider from "react-slick";
import GptLayout from "../component/gptLayout";
import PricingSection from "../component/gptPages/PricingSection";
import { aiMentorProfiles } from "../static/arrays/aiMentorProfiles";
import { testimonials } from "../static/arrays/testimonials";
import { faqData } from "../static/arrays/faqs";
import whatCanDo1 from "../images/whatWeDoImg/whatCanDo1.png";
import whatCanDo2 from "../images/whatWeDoImg/whatCanDo2.png";
import whatCanDo3 from "../images/whatWeDoImg/whatCanDo3.png";
import whatCanDo4 from "../images/whatWeDoImg/whatCanDo4.png";
import whatCanDo5 from "../images/whatWeDoImg/whatCanDo5.png";
import whatCanDo6 from "../images/whatWeDoImg/whatCanDo6.png";
import whatCanDo7 from "../images/whatWeDoImg/whatCanDo7.png";
import whatCanDo8 from "../images/whatWeDoImg/whatCanDo8.png";
import whatCanDo9 from "../images/whatWeDoImg/whatCanDo9.png";
import whatCanDo10 from "../images/whatWeDoImg/whatCanDo10.png";
import whatCanDo11 from "../images/whatWeDoImg/whatCanDo11.png";
import whatCanDo12 from "../images/whatWeDoImg/whatCanDo12.png";
import { FiArrowUpRight } from "react-icons/fi";

const Home = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const handleNavigate = () => {
    if (auth?.user?._id) {
      navigate("/chat");
    } else {
      navigate("/doubt-solving");
    }
  };

  const handleRedirectToChat = (query) => {
    if (query === "/spoken-english") {
      navigate(query);
    } else if (auth?.user?._id) {
      navigate(`/chat?type=${query}&isRedirected=true`);
    } else {
      window.location.href = `${process.env.REACT_APP_REDIRECT_LINK}/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
    }
  };

  const profileSlidersettings = {
    dots: true, // Show navigation dots
    infinite: true, // Infinite scrolling
    speed: 500, // Transition speed in ms
    slidesToShow: 3, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay speed (in ms)
    arrows: false, // Show next/prev arrows
    responsive: [
      {
        breakpoint: 500, // For screen widths less than 500px
        settings: {
          slidesToShow: 1, // Show 1 slide
          slidesToScroll: 1, // Scroll 1 slide
        },
      },
    ],
  };
  const testimonySlidersettings = {
    dots: true, // Show navigation dots
    infinite: true, // Infinite scrolling
    speed: 500, // Transition speed in ms
    slidesToShow: 3, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay speed (in ms)
    arrows: false, // Show next/prev arrows
    responsive: [
      {
        breakpoint: 500, // For screen widths less than 500px
        settings: {
          slidesToShow: 1, // Show 1 slide
          slidesToScroll: 1, // Scroll 1 slide
        },
      },
    ],
  };

  // FAQ ANswer mobile
  const [openTestimonyIndex, setOpenTestimonyIndex] = useState(0);
  const showFaqAnswer = (index) => {
    setOpenTestimonyIndex(index);
  };

  const handleNavigateHowtoUse = (itm) => {
    if (itm?.desc === "AI INET Mentor") {
      navigate(`/${itm?.profileButtonLink}`);
    } else {
      window.open(itm?.profileButtonLink, "_blank", "noopener,noreferrer");
    }
  };

  const whatCanDoContent = [
    {
      cardImg: whatCanDo1,
      title: "Practice Spoken English",
      description:
        "Practice spoken English and enhance your power of expression for your upcoming SSB/AFSB/NSB interview with SSB-GPT's AI mentor, Mark.",
      startLink: "/chat?type=spoken-english",
    },
    {
      cardImg: whatCanDo2,
      title: "Mock SSB Psychology Test",
      description:
        "Get your psychology dossier reviewed for the upcoming SSB/AFSB/NSB interview with SSB-GPT's AI mentor, Captain Alpha.",
      startLink: "/chat?type=mock-psychology",
    },
    {
      cardImg: whatCanDo3,
      title: "Practice for CPSS",
      description:
        "Practice Cognitive Ability and Psychomotor Tests for CPSS on simulations guided by AI CPSS expert Sanjeev Kumar.",
      startLink: "/chat?type=CPSS",
    },
    {
      cardImg: whatCanDo2,
      title: "Practice OIR Test",
      description:
        "SSB-GPT now offers unlimited access to OIR tests, boosting your chances of getting screened in.",
      startLink: "/chat?type=oir-test",
    },
    {
      cardImg: whatCanDo4,
      title: "SSB Mock Interview",
      description:
        "Practice unlimited SSB personal interviews with AI SSB Expert Captain Alpha and receive her feedback to face the real interview with confidence.",
      startLink: "/chat?type=mock-interview",
    },
    {
      cardImg: whatCanDo5,
      title: "Practice GTO",
      description:
        "Now, practice GTO outdoor tasks in a 3D simulation guided by Captain Alpha.",
      startLink: "/chat?type=ssb-gto",
    },
    {
      cardImg: whatCanDo6,
      title: "Get OLQs Analysed",
      description:
        "Assess your OLQs with MCQ-based psychometric questions to improve self-analysis for the upcoming SSB.",
      startLink: "/chat?type=olq-analysis",
    },
  ];

  return (
    <Fragment>
      <CustomHelmet
        title="INET-GPT: Your INET Self Preparation Tool"
        description="Prepare effectively for your INET/SSB/AFSB/NSB/CDS interview with INET-GPT, a free self-preparation tool."
      />
      <GptLayout>
        <div className="container">
          <section className="home_page">
            <section className="banner_section">
              <div className="left">
                <span>Looking for your own personal INET Mentor?</span>
                <h2>
                  Prepare for your INET Exam
                  <br /> with an <strong>AI INET Mentor!</strong>
                </h2>
                <p>
                  Unlock success with INET-GPT: Strengthen your command over
                  English, General Science, Reasoning, Maths, and GK. Let your
                  AI INET Mentor guide you with personalized insights to
                  confidently crack the INET exam.
                </p>
                <p>
                  Start your <strong>INET</strong> journey for
                  <span> FREE</span>
                </p>
                <div className="btn_wrap">
                  {auth?.user?._id ? (
                    <button className="go_btn" onClick={() => handleNavigate()}>
                      <GiNothingToSay /> Ask your AI INET Mentor Now
                    </button>
                  ) : (
                    <button className="go_btn" onClick={() => handleNavigate()}>
                      <GiNothingToSay /> Show Me How You’ll Fix My INET
                      Preparation
                    </button>
                  )}
                  <button className="app_btn">
                    <BiLogoPlayStore /> Download on Google Play
                  </button>
                </div>
              </div>
              <div className="right">
                <img src={homeBanner} alt="home-banner" />
              </div>
            </section>

            <section className="mentor_section">
              <div className="title">
                <h2>
                  INET-GPT: YOUR AI MENTOR, {" "}
                  <strong> GUIDING YOU LIKE A REAL INET EXPERT!</strong>
                </h2>
                <p>
                  Experience the power of INET-GPT—your AI mentor for instant
                  answers and expert guidance. Perfect for those searching for
                  ‘INET GPT,’ ‘INET preparation,’ or ‘INET coaching near me.
                </p>
              </div>
              <img src={home2} alt="home2" />
            </section>

            <section className="ai_ssb">
              <div className="title">
                <h2>AI INET Mentors</h2>
                <p>Meet Our AI INET Mentor</p>
              </div>
              {/* SLIDER ONLY FOR MOBILE VERSION START */}
              <div className="mobileSlider">
                <Slider {...profileSlidersettings}>
                  {aiMentorProfiles?.map((item, itemIndex) => (
                    <div className="profile" key={itemIndex}>
                      <div className="left">
                        <img src={item.profilePicMobile} alt="home_banner" />
                      </div>

                      <div className="right">
                        <div className="title">
                          <h4>{item.name}</h4>
                          <p>{item.desc}</p>

                          <div className="btnGrp">
                            {item?.profileButtonLink !== "" && (
                              <button
                                onClick={() => handleNavigateHowtoUse(item)}
                              >
                                <FaUser /> Profile
                              </button>
                            )}
                            <button
                              onClick={() =>
                                handleRedirectToChat(item?.chatButtonLink)
                              }
                            >
                              <HiChatBubbleOvalLeftEllipsis />{" "}
                              {item.name === "Mark" ? "Talk" : "Chat"}
                            </button>
                          </div>
                        </div>
                        <ul>
                          {item.features.map((subItem, subItemIndex) => (
                            <li key={subItemIndex}>
                              <p>
                                <PiStarFourThin />
                              </p>
                              <p>{subItem}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
              {/* SLIDER ONLY FOR MOBILE VERSION ENDS */}

              {/* PROFILE CARDS FOR WEB - DESKTOP START */}
              <div className="desktop_slider">
                {aiMentorProfiles?.map((item, itemIndex) => (
                  <div className="profile" key={itemIndex}>
                    <div className="left">
                      <img src={item.profilePic} alt="home_banner" />
                    </div>

                    <div className="right">
                      <div className="title">
                        <h4>{item.name}</h4>
                        <p>{item.desc}</p>
                        <div className="btnGrp">
                          {item?.profileButtonLink !== "" && (
                            <button
                              onClick={() => handleNavigateHowtoUse(item)}
                            >
                              <FaUser /> Profile
                            </button>
                          )}
                          <button
                            onClick={() =>
                              handleRedirectToChat(item?.chatButtonLink)
                            }
                          >
                            <HiChatBubbleOvalLeftEllipsis />{" "}
                            {item.name === "Mark" ? "Talk" : "Chat"}
                          </button>
                        </div>
                      </div>
                      <ul>
                        {item.features.map((subItem, subItemIndex) => (
                          <li key={subItemIndex}>
                            <p>
                              <PiStarFourThin />
                            </p>
                            <p>{subItem}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
              {/* PROFILE CARDS FOR WEB - DESKTOP ENDS */}
            </section>

            <PricingSection />

            <section className="user_testimonials">
              <div className="title">
                <h2>User Words</h2>
                <p>
                  Here are some delightful words from our satisfied users. The
                  very <br />
                  essence that fuels our passion! 😊
                </p>
              </div>
              <div className="testimonial_card_plan desktop">
                {testimonials?.map((testimonial, index) => (
                  <div key={index} className="testimonial-card">
                    <div className="head">
                      <img src={testimonial?.image} alt="yser-ig"></img>
                      <div>
                        <h3>{testimonial.name}</h3>
                        <p>{testimonial.city}</p>
                      </div>
                    </div>
                    <div className="stars">{"★".repeat(testimonial.stars)}</div>
                    <p>{testimonial.feedback}</p>
                  </div>
                ))}
              </div>
              {/* Testimonial card slider start */}
              <div className="testimonial_card_plan mobile">
                <Slider {...testimonySlidersettings}>
                  {testimonials.map((testimonial, index) => (
                    <div key={index} className="testimonial-card">
                      <div className="head">
                        <img src={testimonial?.image} alt="yser-ig"></img>
                        <div>
                          <h3>{testimonial.name}</h3>
                          <p>{testimonial.city}</p>
                        </div>
                      </div>
                      <div className="stars">
                        {"★".repeat(testimonial.stars)}
                      </div>
                      <p>{testimonial.feedback}</p>
                    </div>
                  ))}
                </Slider>
              </div>
              {/* Testimonial card slider ends */}
            </section>

            <section className="whatCanDo">
              <div className="heading">What Can You Do with INET-GPT?</div>
              <div className="gptCards">
                {whatCanDoContent?.map((item, itemIndex) => (
                  <div className="card" key={itemIndex}>
                    <img src={item.cardImg} alt="card" />
                    <Link to={item.startLink} className="gptName">
                      {item.title}
                    </Link>
                    <p className="description">{item.description}</p>
                    {/* <Link to={item.startLink} className="coming_soon">
                      Start <FiArrowUpRight />
                    </Link> */}
                  </div>
                ))}
                <div className="card">
                  <div className="plus_content">
                    <div className="plusIcon">
                      <FaPlusCircle />
                    </div>
                    <div className="text">And Much More</div>
                  </div>
                </div>
              </div>
            </section>

            <section className="faqs">
              <div className="title">
                <h2>FAQs</h2>
                <p>Get answers to most asked questions about INET-GPT</p>
              </div>
              <div className="faq_list">
                {faqData.map((item, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => showFaqAnswer(index)}
                  >
                    <h3 className="faq-question">{item.question}</h3>
                    <p
                      className={`faq-answer ${
                        openTestimonyIndex === index ? "show" : ""
                      }`}
                    >
                      {item.answer}
                    </p>
                  </div>
                ))}
              </div>
            </section>
          </section>
        </div>
      </GptLayout>
    </Fragment>
  );
};

export default Home;
